import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { EditableDocumentTitle } from './EditableDocumentTitle.tsx';

export const DocumentTitle = Node.create({
  name: 'title',

  content: 'inline*',
  defining: true,
  group: 'title',
  marks: '',
  priority: 1002,

  addNodeView() {
    return ReactNodeViewRenderer(EditableDocumentTitle);
  },

  renderHTML({ node, HTMLAttributes }) {
    return ['h1', HTMLAttributes, node.textContent];
  },

  parseHTML: () => [{ tag: 'h1:first-child' }]
});
